import SystemCustomDivider from "./SystemCustomDivider";

export default function SystemResultsSummaryDivider() {
    // Used in ResultsSummary to separate numbered score and
    // detailed score

    // BUILD
    return (
        <div className={"h-full py-[18px] pl-[4px] pr-[10px] mr-[6px]"}>
            <SystemCustomDivider isVertical={true}
                                 color={"bg-greyLight5"} />
        </div>
    );
}